import type { OutreachBulkSend } from '@discovr/types';
import { Button } from '../../../components/ui/button';
import { DownloadSimple, UsersThree } from '../../../design-system/icons';
import { BulkSendsMenu } from './BulkSendsMenu';

/** The Outreach top-bar buttons (Figma), published into the app shell's
 *  right-hand slot while the inbox is on screen. */
interface OutreachHeaderActionsProps {
  onImport?: () => void;
  /** Opens the Discovery Pool picker; absent without outreach write access. */
  onPull?: () => void;
  /** The import needs the campaign's platform, so it waits for the header. */
  importDisabled?: boolean;
  bulkSends?: OutreachBulkSend[];
  onOpenBulkSend?: (batchId: string) => void;
}

export function OutreachHeaderActions({ onImport, onPull, importDisabled = false, bulkSends = [], onOpenBulkSend }: OutreachHeaderActionsProps) {
  return (
    <div className="flex items-center gap-2">
      {onOpenBulkSend ? <BulkSendsMenu sends={bulkSends} onOpen={onOpenBulkSend} /> : null}
      <Button size="sm" disabled={!onPull} onClick={onPull}>
        <UsersThree size={16} />
        Pull creators
      </Button>
      {onImport ? (
        <Button size="sm" variant="outline" disabled={importDisabled} title={importDisabled ? 'Loading the campaign…' : undefined} onClick={onImport}>
          <DownloadSimple size={16} />
          Import CSV
        </Button>
      ) : null}
    </div>
  );
}
